import React from "react";
import { Form, Input, InputNumber, Checkbox, Select, } from "antd";
import { compositionOptions, propertyTypeSections } from "./constants";
import { FormItem } from "./styles";

const { Option } = Select;

export default function PropertyComposition({ selectedFields, form, handleSubmit, propertyTypeId, }) {
  const property = propertyTypeSections.find(x => x.propertyType === propertyTypeId);
  return (
    <Form layout="vertical" form={form} style={{ width: '100%', }} onFinish={handleSubmit}
      onFinishFailed={(values) =>
        console.log('onFinishFailed', values)}>
      {compositionOptions.map((composition) => {
        const selectedKeys = selectedFields.find(x => x.key == composition.sectionKey)?.fields;
        if (!selectedKeys) return null;

        const fields = composition.fields.filter((f) =>
          selectedKeys.includes(f.key)
        );

        if (fields.length === 0) return null;

        return (
          <div key={composition.sectionKey} style={{ margin: '1rem 0', width: '100%', }}>
            <h3 style={{ fontWeight: "bold", marginBottom: '1rem', }}>
              {property?.sections?.find(x => x.key == composition.sectionKey)?.name || composition.section}
            </h3>
            <div style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'rows', gap: '1rem', justifyContent: 'space-between', }}>
              {fields.map((field) => {
                // const fieldName = [composition.section, field.key].join(".");
                const fieldName = [field.key].join(".");


                if (field.type === "number") {
                  return (
                    <FormItem key={fieldName} name={fieldName} label={field.label} rules={[{
                      required: field.required,
                      message: `Campo ${field.label} é obrigatório!`,
                    }]}>
                      <InputNumber style={{ width: "100%" }} />
                    </FormItem>
                  );
                }

                if (field.type === "bool") {
                  return (
                    <FormItem
                      ischeckbox={true}
                      key={fieldName}
                      name={fieldName}
                      valuePropName="checked"
                      rules={[{
                        required: field.required,
                        message: `Campo ${field.label} é obrigatório!`,
                      }]}
                    >
                      <Checkbox>{field.label}</Checkbox>
                    </FormItem>
                  );
                }

                if (field.type === "text" && field.options?.length) {
                  return (
                    <FormItem key={fieldName} name={fieldName} label={field.label} rules={[{
                      required: field.required,
                      message: `Campo ${field.label} é obrigatório!`,
                    }]}>
                      <Select allowClear placeholder="Selecione">
                        {field.options.map((opt) => (
                          <Option key={opt.value} value={opt.value}>
                            {opt.label}
                          </Option>
                        ))}
                      </Select>
                    </FormItem>
                  );
                }

                return (
                  <FormItem key={fieldName} name={fieldName} label={field.label} rules={[{
                    required: field.required,
                    message: `Campo ${field.label} é obrigatório!`,
                  }]}>
                    <Input />
                  </FormItem>
                );
              })}
            </div>
            <hr />
          </div>
        );
      })}
    </Form>
  );
}
